import { render, staticRenderFns } from "./DataNotFound.vue?vue&type=template&id=19097727&scoped=true&"
import script from "./DataNotFound.vue?vue&type=script&lang=js&"
export * from "./DataNotFound.vue?vue&type=script&lang=js&"
import style0 from "./DataNotFound.vue?vue&type=style&index=0&id=19097727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19097727",
  null
  
)

export default component.exports